<template>
  <div class="screen-refreshing">
    <div class="screen-refreshing__overlay"></div>
    <div class="screen-refreshing__box">
      <div class="screen-refreshing__box__container">
        <div class="screen-refreshing__box__container__title">
          {{ $t('screen.refreshing.label') }}
        </div>
        <ui-loader class="screen-refreshing__box__container__loader" stroke="#A4B0C8" />
      </div>
    </div>
  </div>
</template>

<script>
import UiLoader from '@/components/UI/Loader.vue'

export default {
  name: 'ScreenRefreshing',
  components: {
    UiLoader,
  },
}
</script>

<style lang="scss" scoped>
.screen-refreshing {
  @include wrapper($justify: center, $zIndex: 100, $align: center);

  padding: $gutter-sm;

  &__overlay {
    @include overlay;
  }

  &__box {
    @include box(101);

    border-radius: $radius-default;
    height: initial;

    &__container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: $spacing-sm;

      &__title {
        @include title(1.125rem);

        text-align: center;
      }

      &__loader {
        margin-top: $spacing-md;
      }
    }
  }
}
</style>
